export enum SupplierResponseItemExtraFeeKind {
  Unknown = 0,
  DisposalFee = 1,
  Deposit = 2,
  LeadSurcharge = 3,
  EnvironmentalSurcharge = 4,
  TradeInCredit = 5,
}